import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import NavLinkWithQuery from '../../../components/shared/nav-link-with-query'
import Button from '../../../components/button'
import styles from './signup-nav-button.css'
import { SIGN_UP_SCREENS } from '../../../constants'

function SignUpNavButton({ searchIsClicked }) {
  return (
    <>
      <NavLinkWithQuery
        exact
        analyticsLabel="sign up"
        to={{ pathname: SIGN_UP_SCREENS.SIGN_UP.path }}
        className={classNames(styles.navLink, searchIsClicked && styles.navLinkWhileSearching)}
      >
        <Button
          text="sign up"
          e2eIdentifier="nav-sign-up"
          className={styles.linkButton}
        />
      </NavLinkWithQuery>
    </>
  )
}

SignUpNavButton.propTypes = {
  searchIsClicked: PropTypes.bool.isRequired
}

export default SignUpNavButton
